export class UserModel {
  id: string;
  name: string;
  email: string;
  password: string;
  verify: boolean;
  admin: boolean;
  roles: string[];
  identities: string[] = [];
  hasPassword: boolean = true;
  whatsappPhone: string | null = null;
  pendingPhone: string | null = null;
  mfaEnabled: boolean = false;
}
